import { Injectable, NgModule, Optional, SkipSelf } from '@angular/core';
import { HttpClient,} from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';





import { Attributes, IntersectionObserverHooks, LAZYLOAD_IMAGE_HOOKS, LazyLoadImageModule } from 'ng-lazyload-image';


import { SocialAuthServiceConfig, GoogleLoginProvider } from '@abacritt/angularx-social-login';
import { IMAGE_CONFIG, IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';

import { NetworkStatusService } from '../services/network-status.service';
import { OwlService } from '../services/owl.service';
import { map, Observable } from 'rxjs';

@Injectable()
export class LazyLoadImageHooks extends IntersectionObserverHooks {
  private http: HttpClient;

  constructor(http: HttpClient) {
    super();
    this.http = http;
  }

  override loadImage({ imagePath }: Attributes): Observable<string> {
    // Load the image through `HttpClient` and cancel the request if the user change page or the image gets removed
    return this.http.get(imagePath, { responseType: 'blob' }).pipe(map(blob => URL.createObjectURL(blob)));
  }
}

@NgModule({
  imports: [LazyLoadImageModule,],
  declarations: [],
  exports: [],
  providers: [
    OwlService,
    NetworkStatusService,
    DatePipe,
    MessageService,
    { provide: LAZYLOAD_IMAGE_HOOKS, useClass: LazyLoadImageHooks },
    {
        provide: 'SocialAuthServiceConfig',
        useValue: {
          autoLogin: false,
          providers: [
            {
              id: GoogleLoginProvider.PROVIDER_ID,
              // provider: new GoogleLoginProvider('994538268053-2kkjjmft976rtu54fghuans1sd9qbldk.apps.googleusercontent.com') // new testing
              // provider: new GoogleLoginProvider('340040744741-91l8gh1if771irs6a75s0irfbvoe375r.apps.googleusercontent.com') //testing server
              provider: new GoogleLoginProvider('668053243109-50smcfs4ooj50p3esca6s1fv4jni134s.apps.googleusercontent.com')// Production server
             
            },
          ],
          onError: (err) => {
            console.error(err);
          }
        } as SocialAuthServiceConfig,
      },
      { provide: LAZYLOAD_IMAGE_HOOKS, useClass: LazyLoadImageHooks },
    
      {
        provide: IMAGE_CONFIG,
        useValue: {
          disableImageSizeWarning: true, 
          disableImageLazyLoadWarning: false
        }
      },{
        provide: IMAGE_LOADER,
        useValue: (config: ImageLoaderConfig) => {
          // Cloudinary images (contains 'cloudinary.com')
          if (config.src.includes('cloudinary.com')) {
            return config.src; // Use as-is
          }
          
          // Second Cloudinary domain
          if (config.src.includes('other-cloudinary.com')) {
            return config.src.replace('img/', 'q_auto,f_auto/');
          }
          
          // S3 bucket images
          if (config.src.includes('s3.amazonaws.com')) {
            return `${config.src}`;
          }
          
          // Local assets
          if (config.src.startsWith('assets/')) {
            return `${config.src}`;
          }
          
          // Default case
          return config.src;
        }
      }
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule should only be imported once in AppModule');
    }
  }
}
